import styled from 'styled-components';

export const TipaltiIframe = styled.iframe`
  width: 100%;
  height: ${'calc(100vh - 64px)'}; // 64px is the height of the NavBar
`;
